const modes = new Set(['auto', 'fast', 'low', 'few', 'sold_out']);

export function resolveStatus(config, now = Date.now()) {
  if (config.mode === 'sold_out') return 'sold_out';
  const launch = Date.parse(config.launch);
  if (!Number.isFinite(launch) || now < launch) return 'hidden';
  if (config.productState === 'sold_out') return 'sold_out';
  if (config.enabled !== 'true' || config.productState !== 'available') return 'hidden';
  if (!modes.has(config.mode)) return 'hidden';
  if (config.mode !== 'auto') return config.mode;
  const fast = Date.parse(config.fast), low = Date.parse(config.low), few = Date.parse(config.few);
  if (!Number.isFinite(fast) || fast < launch) return 'hidden';
  if (Number.isFinite(low) && low > fast) {
    if (Number.isFinite(few) && few > low && now >= few) return 'few';
    if (now >= low) return 'low';
  }
  return now >= fast ? 'fast' : 'hidden';
}

if (typeof document !== 'undefined') {
  const controllers = new Map();
  function init(root) {
    if (controllers.has(root)) return;
    let busy = false;
    let clockOffset = 0;
    let config = {...root.dataset};
    const labels = JSON.parse(root.querySelector('[data-sc-launch-labels]').textContent);
    const scope = root.closest('section');
    const button = scope?.querySelector('.ws-preview__release');
    const form = scope?.querySelector('.sc-launch-purchase');
    let closed = false;
    const originalButton = button ? {text:button.textContent, disabled:button.disabled} : null;
    const update = () => {
      const status = resolveStatus(config, Date.now() + clockOffset);
      root.hidden = status === 'hidden';
      root.dataset.status = status;
      root.querySelector('[data-sc-launch-status-label]').textContent = labels[status] || '';
      closed = status === 'sold_out';
      if (button && originalButton) {
        button.disabled = closed || config.productState !== 'available' || originalButton.disabled;
        button.textContent = closed ? labels.sold_out : originalButton.text;
      }
    };
    const stopClosed = event => { if (closed) { event.preventDefault(); event.stopImmediatePropagation(); } };
    form?.addEventListener('submit', stopClosed, true);
    async function refresh() {
      if (busy || document.hidden || !root.isConnected || window.Shopify?.designMode) return;
      busy = true;
      try {
        const url = new URL(location.href);
        url.searchParams.set('section_id', config.section);
        url.searchParams.set('_sc_status', Math.floor(Date.now() / 30000));
        const response = await fetch(url, {cache:'no-store', signal:AbortSignal.timeout(10000)});
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('[data-sc-launch-status]');
        if (!fresh || fresh.dataset.section !== config.section) return;
        const serverTime = Date.parse(response.headers.get('date'));
        if (Number.isFinite(serverTime)) clockOffset = serverTime - Date.now();
        const changedAvailability = fresh.dataset.productState !== config.productState;
        const changedClosed = (fresh.dataset.mode === 'sold_out') !== (config.mode === 'sold_out');
        config = {...fresh.dataset};
        update();
        if (changedAvailability || changedClosed) location.reload();
      } catch {} finally { busy = false; }
    }
    const tick = setInterval(() => {
      if (!root.isConnected) { clearInterval(tick); clearInterval(poll); controllers.delete(root); return; }
      if (!document.hidden) update();
    }, 1000);
    const poll = setInterval(refresh, 30000);
    controllers.set(root, {refresh});
    update();
    refresh();
  }
  function scan(scope = document) { scope.querySelectorAll('[data-sc-launch-status]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) controllers.forEach(c => c.refresh()); });
}
